// @flow

const CLOSED: 'closed' = 'closed';
const SHOWING: 'showing' = 'showing';
const MESSAGE_STATES = { CLOSED, SHOWING };

const SHOW: 'show' = 'show';
const CLOSE: 'close' = 'close';
const MESSAGE_EVENTS = { SHOW, CLOSE };

export { MESSAGE_STATES, MESSAGE_EVENTS };
